import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { data } from "../variables/variables";
import {
  getDeliverOrder,
  update_orders_status,
  refresh_time,
} from "./../Pages/apis";
import { formatDateTimeWithSeconds } from "../Utils/dateFormat";
import { Card } from "../Components/cards/Card";

function RoomModal({ roomId }) {
  const [dispatchOrders, setDispatchOrders] = useState([]);
  const [roomsResponse, setRoomsResponse] = useState(false);
  const [responseApi, setResponseApi] = useState(0);
  const [fetchError, setFetchError] = useState("");
  const [order_display, setOrder_Display] = useState([]);
  const [display_banner, setDisplay_banner] = useState(false);
  const [st_id, setSt_id] = useState(0);
  const [order_id, setOrder_id] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [roomModal, setRoomModal] = useState(false);

  const fetchDispatched = useCallback(() => {
    if (!roomId) return;
    const stored = JSON.parse(localStorage.getItem("user"));
    axios
      .get(getDeliverOrder + roomId, {
        headers: { Authorization: "Bearer " + stored?.token },
      })
      .then((res) => {
        if (res.data.status == 200) {
          const raw = res?.data?.dispatched;
          const list = Array.isArray(raw) ? raw : raw != null ? [raw] : [];
          setDispatchOrders(list);
          setRoomsResponse(true);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          // setRedirectLogin(true);
        } else {
          setFetchError(data["error"]);
          setResponseApi(1);
          setRoomsResponse(false);
        }
      });
  }, [roomId]);

  useEffect(() => {
    fetchDispatched();
  }, [fetchDispatched]);

  useEffect(() => {
    if (!roomId) return undefined;
    const ms = Number(refresh_time);
    if (!Number.isFinite(ms) || ms < 1000) return undefined;
    const interval = setInterval(fetchDispatched, ms);
    return () => clearInterval(interval);
  }, [roomId, fetchDispatched]);
  const updateOrder = async (id, status_id) => {
    status_id++;
    const stored = JSON.parse(localStorage.getItem("user"));
    await axios
      .post(
        update_orders_status + id + "/" + status_id,
        { payload: null },
        { headers: { Authorization: "Bearer " + stored?.token } }
      )
      .then((res) => {
        if (res.data.status === 200) {
          let deepCopy = JSON.parse(JSON.stringify(dispatchOrders));
          deepCopy = deepCopy.filter((item) => item?.id != id);
          setDispatchOrders(deepCopy);
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const order_buttons = (ele) => {
    // Delivery module only: show final handoff for dispatched orders.
    if (ele?.status_id === 3) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id)}
        >
          {data["deliver"]}
        </button>
      );
    }
  };

  const ordersForRoom =
    dispatchOrders?.filter((ele) => {
      if (!roomId) return true;
      return (
        Number(ele?.room?.id) === Number(roomId) ||
        String(ele?.room?.id) === String(roomId)
      );
    }) ?? [];

  return (
    <div style={{ height: "100vh" }}>
      <Card>
        {ordersForRoom.length === 0 ? (
          <div className="Card_Body">
            <p className="text-center text-muted mb-0">
              No dispatched orders for this room.
            </p>
          </div>
        ) : null}
        {ordersForRoom.map((ele) => (
          <div key={ele?.id} className="Card_Body">
            <div className="card_body_content">
              <div className="card_content_left">
                <h5 className="text-bold1">{data["item"]}</h5>
                <p>{ele?.menu?.name}</p>
              </div>
              <div className="card_content_left1">
                <h5 className="text-bold1">{data["qty"]}</h5>
                <p>{ele?.qty}</p>
              </div>
              <div className="card_body_centent_center">
                <h5 className="text-bold1">{data["status"]}</h5>

                <p>{ele?.status?.name}</p>
              </div>
              <div className="card_body_content_right">
                {order_buttons(ele)}

                <small>
                  {formatDateTimeWithSeconds(ele?.created_at)}
                </small>
              </div>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}

export default RoomModal;
